export const ALBUM_UPDATE_WIP_ = "ALBUM_UPDATE_WIP_";

export const HAS_ACCEPTED_PUSH_NOTIFICATIONS =
  "has-accepted-push-notifications";

export const HAS_REJECTED_PUSH_NOTIFICATIONS =
  "has-rejected-push-notifications";

export const SEEN_DISMISSED_DOWNLOAD_APP_CTA_AT =
  "seen-dismissed-download-app-cta-at";
